module.exports = __webpack_public_path__ + "static/img/gfs.136da72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/gfs.png
// module id = mj9T
// module chunks = 9